import { useState, useEffect } from "react";
import { useAuth } from "../lib/auth";
import { Navigate, useNavigate } from "react-router-dom";
import { fmtErr } from "../lib/api";
import { Sprout } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const original = document.title;
    document.title = "Adi vs Kudrat — Sign in";
    return () => { document.title = original; };
  }, []);

  if (user) return <Navigate to="/" replace />;

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = await login(username.trim().toLowerCase(), password);
      nav(u.role === "admin" ? "/admin" : "/");
    } catch (e) { setErr(fmtErr(e)); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md nb-card p-8" data-testid="login-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-xl bg-gold border-2 border-ink shadow-[3px_3px_0_0_#171717] flex items-center justify-center">
            <Sprout size={26} strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display font-black text-2xl leading-none">Adi vs Kudrat</div>
            <div className="text-xs font-mono uppercase tracking-widest text-neutral-500 mt-1">30-day challenge</div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 mb-6" data-testid="login-avatars">
          <img src="https://customer-assets-agu9un31.emergentagent.net/job_duo-challenge-13/artifacts/yui99v18_ChatGPT%20Image%20Jul%2018%2C%202026%2C%2001_09_16%20AM.png"
               alt="Adi" className="w-28 h-28 sm:w-32 sm:h-32 rounded-full border-2 border-ink object-cover shadow-[6px_6px_0_0_#16A34A]" />
          <div className="font-display font-black text-3xl sm:text-4xl text-ink">VS</div>
          <img src="https://customer-assets-agu9un31.emergentagent.net/job_duo-challenge-13/artifacts/dp91bc8b_ChatGPT%20Image%20Jul%2018%2C%202026%2C%2001_07_41%20AM.png"
               alt="Kudrat" className="w-28 h-28 sm:w-32 sm:h-32 rounded-full border-2 border-ink object-cover shadow-[-6px_6px_0_0_#F59E0B]" />
        </div>

        <h1 className="font-display font-black text-3xl mb-2">Sign in</h1>
        <p className="text-neutral-600 mb-6">Track your day. Stack your streaks. Grow together.</p>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <label className="text-xs font-bold uppercase tracking-widest">Username</label>
          <input data-testid="login-username" className="nb-input" value={username} onChange={(e) => setU(e.target.value)} placeholder="username" autoFocus autoComplete="username" />
          <label className="text-xs font-bold uppercase tracking-widest">Password</label>
          <input data-testid="login-password" type="password" className="nb-input" value={password} onChange={(e) => setP(e.target.value)} placeholder="••••••••" autoComplete="current-password" />
          {err && <div data-testid="login-error" className="chip" style={{ background: "#FEE2E2", borderColor: "#171717" }}>{err}</div>}
          <button data-testid="login-submit" disabled={busy} className="nb-btn bg-adi text-white py-3 mt-2">
            {busy ? "Signing in..." : "Enter Challenge"}
          </button>
        </form>
      </div>
    </div>
  );
}
